<template>
	<view :class="['text-overlay', expanded ? 'is-expanded' : '']">
		<view v-if="title" class="text-overlay-title">{{ title }}</view>
		<view class="text-overlay-content">
			<slot></slot>
		</view>
		<view v-if="expanded" class="text-overlay-collapse" @click="expanded = false">收起</view>
		<view v-if="!expanded" class="text-overlay-mask" :style="{ height: `${maskHeight}px` }">
			<view class="text-overlay-action" @click="expanded = true">{{ expandText }}</view>
		</view>
	</view>
</template>

<script setup>
	import { ref } from 'vue'

	defineProps({
		title: {
			type: String,
			default: ''
		},
		maskHeight: {
			type: Number,
			default: 86
		},
		expandText: {
			type: String,
			default: '查看全部'
		}
	})

	const expanded = ref(false)
</script>

<style scoped>
	.text-overlay {
		display: block;
		box-sizing: border-box;
		position: relative;
		margin-bottom: 16px;
		padding: 14px 16px;
		border: 1px solid var(--glass-border);
		border-radius: 8px;
		background: var(--glass-bg);
		color: var(--text-secondary);
		font-size: 13px;
		line-height: 1.7;
		overflow: hidden;
	}

	.text-overlay-title {
		margin-bottom: 6px;
		color: var(--text-primary);
		font-size: 15px;
		font-weight: 600;
	}

	.text-overlay-content {
		max-height: 100px;
		overflow: hidden;
	}

	.is-expanded .text-overlay-content {
		max-height: none;
	}

	.text-overlay-mask {
		position: absolute;
		left: 0;
		right: 0;
		bottom: 0;
		display: flex;
		justify-content: center;
		align-items: flex-end;
		padding-bottom: 14px;
		background: linear-gradient(to bottom, transparent 0%, var(--glass-bg) 70%);
	}

	.text-overlay-action {
		padding: 4px 8px;
		border: 0;
		background: transparent;
		color: var(--accent);
		font-size: 11px;
		cursor: pointer;
	}

	.text-overlay-collapse {
		padding-top: 6px;
		color: var(--accent);
		font-size: 11px;
		text-align: center;
		cursor: pointer;
	}

	.is-expanded .text-overlay-mask {
		display: none;
	}
</style>
